import React from "react";
import { NavLink } from "react-router-dom";
import {useNavigate} from "react-router-dom";

interface SidebarProps {
  open: boolean;
  isMobile: boolean;
  theme: "dark" | "light";
  onLinkClick: () => void;
  onThemeToggle: () => void;
  onClose: () => void;
}

const links = [
  { to: "/Matrix",              label: "Overview",     icon: "⬡" },
  { to: "/Matrix/logs",          label: "Live Logs",    icon: "▤" },
  // { to: "/errors",        label: "Errors",       icon: "⚠" },
  // { to: "/actions",       label: "Action Queue", icon: "✓" },
  // { to: "/insights",      label: "Insights",     icon: "◎" },
  // { to: "/trends",        label: "Trends",       icon: "↗" },
  { to: "/Matrix/vm-overview",   label: "VM Overview",  icon: "🖥" },
  { to: "/Matrix/vm-containers", label: "Containers",   icon: "📦" },
  // { to: "/vm-logs",       label: "VM Logs",      icon: "📝" },
];

const Sidebar: React.FC<SidebarProps> = ({ open, isMobile, theme, onLinkClick, onThemeToggle, onClose }) => {
  const navigate = useNavigate();
  return (
    <>
      {/* Mobile backdrop */}
      {isMobile && open && (
        <div
          onClick={onClose}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 15,
          }}
        />
      )}

      <aside
        style={{
          width: 220,
          height: "100vh",
          background: "var(--surface)",
          borderRight: "1px solid var(--border)",
          display: isMobile ? "flex" : open ? "flex" : "none",
          flexDirection: "column",
          padding: "24px 0",
          flexShrink: 0,
          position: isMobile ? "fixed" : "relative",
          top: 0,
          left: isMobile ? (open ? 0 : -220) : 0,
          zIndex: 20,
          boxShadow: isMobile && open ? "0 20px 60px rgba(0,0,0,0.3)" : "none",
          transition: isMobile ? "left 0.25s ease" : "none",
          overflow: "hidden",
        }}
      >
        {/* Brand */}
        <div style={{ padding: "0 20px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text)" }}>Matrix Monitor</div>
            <div style={{ fontSize: 10, color: "var(--muted)", marginTop: 3 }}>API Analytics</div>
          </div>
          {isMobile && (
            <button
              onClick={onClose}
              style={{ border: "none", background: "transparent", color: "var(--text)", fontSize: 20, cursor: "pointer", lineHeight: 1 }}
              aria-label="Close menu"
            >
              ×
            </button>
          )}
        </div>

        {/* Nav links */}
        <nav style={{ flex: 1, overflowY: "auto" }}>
          {links.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/Matrix"}
              onClick={onLinkClick}
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "10px 20px",
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? "var(--text)" : "var(--muted)",
                background: isActive ? "var(--surface-soft)" : "transparent",
                borderLeft: isActive ? "3px solid var(--primary)" : "3px solid transparent",
                textDecoration: "none",
                transition: "background 0.15s, color 0.15s",
              })}
            >
              <span style={{ fontSize: 15 }}>{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        {/* <div style={{ padding: "16px 20px", borderTop: "1px solid var(--border)" }}>
          <button
            onClick={onThemeToggle}
            style={{
              width: "100%",
              padding: "8px 12px",
              background: "var(--surface-soft)",
              border: "1px solid var(--border)",
              borderRadius: 6,
              color: "var(--text)",
              fontSize: 12,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            {theme === "dark" ? "☀️ Light mode" : "🌙 Dark mode"}
          </button>
        </div> */}
        <div style={{ padding: "16px 20px", borderTop: "1px solid var(--border)" }}>
          <button
            onClick={() => { navigate('/SysAdmin')} }
            style={{
              width: "100%",
              padding: "15px 0px",
              background: "var(--surface-soft)",
              border: "1px solid var(--border)",
              borderRadius: 6,
              color: "var(--text)",
              fontSize: 12,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Back to SysAdmin
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
